export interface IRealEstateReport {
  realEstateReportId: number;
  reportName: string;
  updateTimestamp: string;
  status: ERealEstateReportStatus;
  reportFiles: string[];
  date: string;
  isPublic: boolean;
}

export enum ERealEstateReportStatus {
  NEW = 'NEW',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}
